import React from 'react';

export default function WindowsIcon () {
    return (
<svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 3.66423L10.9494 2.22832L10.9543 12.3988L0.010125 12.4587L0 3.66423ZM10.9442 13.5705L10.9528 23.7498L0.00859091 22.3009L0.00797727 13.5023L10.9442 13.5705ZM12.2715 2.04041L26.7895 0V12.2693L12.2715 12.3804V2.04041ZM26.7929 13.6663L26.7895 25.8803L12.2715 23.9073L12.2513 13.6435L26.7929 13.6663Z" fill="white"/>
</svg>
);
};
